module.exports = "\n<bigbools-component></bigbools-component>\n<a id=\"hinnasto-tilaa\"></a>\n<order-component></order-component>\n<a id=\"yhteys\"></a>\n<contact-component></contact-component>\n\n<p-dialog header=\"Kirjaudu sisään\" [(visible)]=\"loginOpen\">\n   <!-- Käyttäjätunnnus: <input [(ngModel)]=\"username\" /><br />\n    Salasana: <input type=\"password\" [(ngModel)]=\"password\" /><br />\n    {{ user | json }} -->\n    <iframe src=\"/admin/login\"></iframe>\n    <button class=\"btn btn-success btn-xs\" (click)=\"login()\">Kirjaudu</button>\n</p-dialog>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/frontpage/frontpage.component.html
// module id = 470
// module chunks = 2